import { useState, useEffect } from "react";
import {
    ApplyBtn,
    reset,
    dropdowns,
    emissionFilterTooltip,
    DataSelection
} from "../../../../util/constants";
import { Select } from "../../../CommonUIComponents/Select/Select";
import { Button } from "../../..";
import { useSelector, useDispatch } from "react-redux";
import { LoadingIndicatorEmbed } from "../../../CommonUIComponents/LoadingIndicator/LoadingIndicatorEmbed";
import { Tooltip } from "../../../CommonUIComponents/Tooltip/Tooltip";
import { setselectedUIAllFilters, setSelectedAllLevels } from "../../../../store/slices/forecastSlice";
import { Modal } from "../../../CommonUIComponents/Modal/Modal";
import { EmissionIcon } from "../../../../icons";
import { isEqual } from "lodash";

function ModalBody({ onApply, onConfirm }) {
    const dispatch = useDispatch();
    const hierarchialData = useSelector((state) => state.forecast.hierarchialData);
    const selectedUIAllFilters = useSelector(
        (state) => state.forecast.selectedUIAllFilters
    );
    const selectedAllLevels = useSelector(
        (state) => state.forecast.selectedAllLevels
    );
    
    const convertEmptyToBlank = (filters) => {
        if (!filters || Array.isArray(filters) || typeof filters !== 'object') return filters;
        const converted = { ...filters };
        Object.keys(converted).forEach(key => {
            if (Array.isArray(converted[key])) {
                converted[key] = converted[key].map(value => value === "" ? "(blank)" : value);
            }
        });
        return converted;
    };
    
    const [selectedUIfilters, setSelectedUIAllFilters] = useState(() => convertEmptyToBlank(selectedUIAllFilters));
    let dropdownOptions = hierarchialData;

    const [showLoader, setLoader] = useState(false);
    const [scopeValue, setScopeValue] = useState([]);
    const [realScopeValue, setRealScopeValue] = useState([]);
    const [errorMsg, setErrorMsg] = useState([]);
    const [validScopes, setValidScopes] = useState([]);
    const keys = [{ field: 'scope', headerName: 'Scope' }, { field: 'category_level1', headerName: 'Category 1' }, { field: 'category_level2', headerName: 'Category 2' }, { field: 'category_level3', headerName: 'Category 3' }, { field: 'region_level1', headerName: 'Region Level1' }, { field: 'region_level2', headerName: 'Region Level2' }, { field: 'region_level3', headerName: 'Region Level3' }, { field: 'entity_level1', headerName: 'Entity Level1' }, { field: 'entity_level2', headerName: 'Entity Level2' }, { field: 'entity_level3', headerName: 'Entity Level3' }, { field: 'entity_level4', headerName: 'Entity Level4' }, { field: 'custom_specification1', headerName: 'Custom 1' }, { field: 'custom_specification2', headerName: 'Custom 2' }, { field: 'custom_specification3', headerName: 'Custom 3' }];
    const [errorInSelection, setErrorInSelection] = useState(false);

    const [emissionSelectAllLevel, setEmissionSelectAllLevel] = useState(selectedAllLevels?.emissionLevel || '');
    const [orgSelectAllLevel, setOrgSelectAllLevel] = useState(selectedAllLevels?.orgLevel || '');
    const [regionSelectAllLevel, setRegionSelectAllLevel] = useState(selectedAllLevels?.geoLevel || '');
    const [customSelectAllLevel, setCustomSelectAllLevel] = useState(selectedAllLevels?.cusLevel || '');
    const [isDropdownChanging, setDropdownChanging] = useState(false);
    const [touchedFields, setTouchedFields] = useState(new Set());
    const hasValidEntries = Object.entries(selectedUIfilters).some(([key, value]) => {
        return Array.isArray(value) && value.length > 0; // Check if the value is an array and has elements
    });

    //Disabling dropdowns based on header filters selection
    const disableDropdowns = (label) => {
        switch (label) {
            case "Category 1":
            case "category_level1":
                if (
                    selectedUIfilters.scope?.length === 0 ||
                    !selectedUIfilters.scope ||
                    selectedUIfilters.category_level1?.length === 0 ||
                    !selectedUIfilters.category_level1
                ) {
                    return true;
                }
                break;
            case "Category 2":
            case "category_level2":
                if (
                    selectedUIfilters.category_level2?.length === 0 ||
                    !selectedUIfilters.category_level2
                ) {
                    return true;
                }
                break;
            case "Category 3":
            case "category_level3":
                if (
                    selectedUIfilters.category_level3?.length === 0 ||
                    !selectedUIfilters.category_level3
                ) {
                    return true;
                }
                break;
            case "Region level 1":
            case "region_level1":
                if (selectedUIfilters.scope?.length === 0 || !selectedUIfilters.scope
                    || selectedUIfilters.region_level1?.length === 0 ||
                    !selectedUIfilters.region_level1
                ) {
                    return true;
                }
                break;
            case "Region level 2":
            case "region_level2":
                if (
                    selectedUIfilters.region_level2?.length === 0 ||
                    !selectedUIfilters.region_level2
                ) {
                    return true;
                }
                break;
            case "Region level 3":
            case "region_level3":
                if (
                    selectedUIfilters.region_level3?.length === 0 ||
                    !selectedUIfilters.region_level3
                ) {
                    return true;
                }
                break;
            case "Entity level 1":
                if (selectedUIfilters.scope?.length === 0 || !selectedUIfilters.scope
                    || selectedUIfilters.entity_level1?.length === 0 ||
                    !selectedUIfilters.entity_level1
                ) {
                    return true;
                }
                break;
            case "Entity level 2":
            case "entity_level2":
                if (
                    selectedUIfilters.entity_level2?.length === 0 ||
                    !selectedUIfilters.entity_level2
                ) {
                    return true;
                }
                break;
            case "Entity level 3":
            case "entity_level3":
                if (
                    selectedUIfilters.entity_level3?.length === 0 ||
                    !selectedUIfilters.entity_level3
                ) {
                    return true;
                }
                break;
            case "Entity level 4":
            case "entity_level4":
                if (
                    selectedUIfilters.entity_level4?.length === 0 ||
                    !selectedUIfilters.entity_level4
                ) {
                    return true;
                }
                break;
            case "Custom level 1":
            case "custom_specification1":
                if (selectedUIfilters.scope?.length === 0 || !selectedUIfilters.scope
                    || selectedUIfilters.custom_specification1?.length === 0 ||
                    !selectedUIfilters.custom_specification1
                ) {
                    return true;
                }
                break;
            case "Custom level 2":
            case "custom_specification2":
                if (
                    selectedUIfilters.custom_specification2?.length === 0 ||
                    !selectedUIfilters.custom_specification2
                ) {
                    return true;
                }
                break;
            case "Custom level 3":
            case "custom_specification3":
                if (
                    selectedUIfilters.custom_specification3?.length === 0 ||
                    !selectedUIfilters.custom_specification3
                ) {
                    return true;
                }
                break;
            default:
                return false;
        }
    };

    // Handling dropdown change
    const handleDropdownChange = async (event, fieldId, id) => {
        setDropdownChanging(true);
        setScopeValue(event);
        setTouchedFields(prev => new Set(prev).add(fieldId));
        const eventsArray = getDropdownValues(fieldId);
        switch (fieldId) {
            case "scope":
                setRealScopeValue(event);
                setSelectedUIAllFilters({
                    ...selectedUIfilters,
                    scope: event,
                    // category_level1: [],
                    // category_level2: [],
                    // category_level3: [],
                    // region_level1: [],
                    // region_level2: [],
                    // region_level3: [],
                    // entity_level1: [],
                    // entity_level2: [],
                    // entity_level3: [],
                    // entity_level4: [],
                    // custom_specification1: [],
                    // custom_specification2: [],
                    // custom_specification3: [],
                    latest_filter: fieldId,
                });
                break;
            case "category_level1":
                if (event?.length === eventsArray?.length && eventsArray?.length !== 1) {
                    setEmissionSelectAllLevel('subCategory1');
                } else {
                    setEmissionSelectAllLevel('');
                }
                setSelectedUIAllFilters({
                    ...selectedUIfilters,
                    category_level1: event,
                    // category_level2: [],
                    // category_level3: [],
                    // region_level1: [],
                    // region_level2: [],
                    // region_level3: [],
                    // entity_level1: [],
                    // entity_level2: [],
                    // entity_level3: [],
                    // entity_level4: [],
                    // custom_specification1: [],
                    // custom_specification2: [],
                    // custom_specification3: [],
                    latest_filter: fieldId,
                });
                break;
            case "category_level2":
                if (event?.length === eventsArray?.length && eventsArray?.length !== 1) {
                    if (emissionSelectAllLevel === '')
                        setEmissionSelectAllLevel('subCategory2');
                } else {
                    setEmissionSelectAllLevel('');
                }
                setSelectedUIAllFilters({
                    ...selectedUIfilters,
                    category_level2: event,
                    // category_level3: [],
                    // region_level1: [],
                    // region_level2: [],
                    // region_level3: [],
                    // entity_level1: [],
                    // entity_level2: [],
                    // entity_level3: [],
                    // entity_level4: [],
                    // custom_specification1: [],
                    // custom_specification2: [],
                    // custom_specification3: [],
                    latest_filter: fieldId,
                });
                break;
            case "category_level3":
                if (event?.length === eventsArray?.length && eventsArray?.length !== 1) {
                    if (emissionSelectAllLevel === '')
                        setEmissionSelectAllLevel('subCategory3');
                } else {
                    setEmissionSelectAllLevel('');
                }
                setSelectedUIAllFilters({
                    ...selectedUIfilters,
                    category_level3: event,
                    // region_level1: [],
                    // region_level2: [],
                    // region_level3: [],
                    // entity_level1: [],
                    // entity_level2: [],
                    // entity_level3: [],
                    // entity_level4: [],
                    // custom_specification1: [],
                    // custom_specification2: [],
                    // custom_specification3: [],
                    latest_filter: fieldId,
                });
                break;
            case "region_level1":
                if (event?.length === eventsArray?.length && eventsArray?.length !== 1) {
                    setRegionSelectAllLevel('regionLevel1');
                } else {
                    setRegionSelectAllLevel('');
                }
                setSelectedUIAllFilters({
                    ...selectedUIfilters,
                    region_level1: event,
                    // region_level2: [],
                    // region_level3: [],
                    // entity_level1: [],
                    // entity_level2: [],
                    // entity_level3: [],
                    // entity_level4: [],
                    // custom_specification1: [],
                    // custom_specification2: [],
                    // custom_specification3: [],
                    latest_filter: fieldId,
                });
                break;
            case "region_level2":
                if (event?.length === eventsArray?.length && eventsArray?.length !== 1) {
                    if (regionSelectAllLevel === '')
                        setRegionSelectAllLevel('regionLevel2');
                } else {
                    setRegionSelectAllLevel('');
                }
                setSelectedUIAllFilters({
                    ...selectedUIfilters,
                    region_level2: event,
                    // region_level3: [],
                    // entity_level1: [],
                    // entity_level2: [],
                    // entity_level3: [],
                    // entity_level4: [],
                    // custom_specification1: [],
                    // custom_specification2: [],
                    // custom_specification3: [],
                    latest_filter: fieldId,
                });
                break;
            case "region_level3":
                if (event?.length === eventsArray?.length && eventsArray?.length !== 1) {
                    if (regionSelectAllLevel === '')
                        setRegionSelectAllLevel('regionLevel3');
                } else {
                    setRegionSelectAllLevel('');
                }
                setSelectedUIAllFilters({
                    ...selectedUIfilters,
                    region_level3: event,
                    // entity_level1: [],
                    // entity_level2: [],
                    // entity_level3: [],
                    // entity_level4: [],
                    // custom_specification1: [],
                    // custom_specification2: [],
                    // custom_specification3: [],
                    latest_filter: fieldId,
                });
                break;
            case "entity_level1":
                if (event?.length === eventsArray?.length && eventsArray?.length !== 1) {
                    setOrgSelectAllLevel('orgLevel1');
                } else {
                    setOrgSelectAllLevel('');
                }
                setSelectedUIAllFilters({
                    ...selectedUIfilters,
                    entity_level1: event,
                    // entity_level2: [],
                    // entity_level3: [],
                    // entity_level4: [],
                    // custom_specification1: [],
                    // custom_specification2: [],
                    // custom_specification3: [],
                    latest_filter: fieldId,
                });
                break;
            case "entity_level2":
                if (event?.length === eventsArray?.length && eventsArray?.length !== 1) {
                    if (orgSelectAllLevel === '')
                        setOrgSelectAllLevel('orgLevel2');
                } else {
                    setOrgSelectAllLevel('');
                }
                setSelectedUIAllFilters({
                    ...selectedUIfilters,
                    entity_level2: event,
                    // entity_level3: [],
                    // entity_level4: [],
                    // custom_specification1: [],
                    // custom_specification2: [],
                    // custom_specification3: [],
                    latest_filter: fieldId,
                });
                break;
            case "entity_level3":
                if (event?.length === eventsArray?.length && eventsArray?.length !== 1) {
                    if (orgSelectAllLevel === '')
                        setOrgSelectAllLevel('orgLevel3');
                } else {
                    setOrgSelectAllLevel('');
                }
                setSelectedUIAllFilters({
                    ...selectedUIfilters,
                    entity_level3: event,
                    // entity_level4: [],
                    // custom_specification1: [],
                    // custom_specification2: [],
                    // custom_specification3: [],
                    latest_filter: fieldId,
                });
                break;
            case "entity_level4":
                if (event?.length === eventsArray?.length && eventsArray?.length !== 1) {
                    if (orgSelectAllLevel === '')
                        setOrgSelectAllLevel('orgLevel4');
                } else {
                    setOrgSelectAllLevel('');
                }
                setSelectedUIAllFilters({
                    ...selectedUIfilters,
                    entity_level4: event,
                    // custom_specification1: [],
                    // custom_specification2: [],
                    // custom_specification3: [],
                    latest_filter: fieldId,
                });
                break;
            case "custom_specification1":
                if (event?.length === eventsArray?.length && eventsArray?.length !== 1) {
                    setCustomSelectAllLevel('customLevel1');
                } else {
                    setCustomSelectAllLevel('');
                }
                setSelectedUIAllFilters({
                    ...selectedUIfilters,
                    custom_specification1: event,
                    // custom_specification2: [],
                    // custom_specification3: [],
                    latest_filter: fieldId,
                });
                break;
            case "custom_specification2":
                if (event?.length === eventsArray?.length && eventsArray?.length !== 1) {
                    if (customSelectAllLevel === '')
                        setCustomSelectAllLevel('customLevel2');
                } else {
                    setCustomSelectAllLevel('');
                }
                setSelectedUIAllFilters({
                    ...selectedUIfilters,
                    custom_specification2: event,
                    // custom_specification3: [],
                    latest_filter: fieldId,
                });
                break;
            case "custom_specification3":
                if (event?.length === eventsArray?.length && eventsArray?.length !== 1) {
                    if (customSelectAllLevel === '')
                        setCustomSelectAllLevel('customLevel3');
                } else {
                    setCustomSelectAllLevel('');
                }
                setSelectedUIAllFilters({
                    ...selectedUIfilters,
                    custom_specification3: event,
                    latest_filter: fieldId,
                });
                break;
            default:
                break;
        }
    };

    // Populating the dropdown values
     const getDropdownValues = (fieldId) => {
        let dataset = [...dropdownOptions];
        const allArraysHaveValues = keys.every(key => {
        const field = key.field;
        return selectedUIfilters[field] ? Array.isArray(selectedUIfilters[field]) && selectedUIfilters[field].length > 0 : false;
    });

        // Iterate through all keys to filter the dataset based on selected values
        keys.forEach(key => {
            if (key?.field !== fieldId) { // Skip the current fieldId
                const selectedValues = selectedUIfilters[key?.field] || [];
                const datasett = dataset?.filter(element => selectedValues?.length > 0 ? (selectedValues?.includes(element[key?.field]) || selectedValues.includes('(blank)')) : []);
                if (datasett?.length !== 0) {
                    dataset = datasett;
                }
            }
        }); 
        if (allArraysHaveValues && !isDropdownChanging) {      
        keys?.forEach(key => {
        const data = dataset?.filter(elem => {
            const elemValue = elem[key?.field];
            const selectedValues = selectedUIfilters[key?.field] || [];
            return selectedValues?.includes(elemValue) || (elemValue === "" && selectedValues?.includes("(blank)"));
        }) || [];
        // Update the dataset if data is found
        if (data?.length !== 0) {
            dataset = data;
        }
    });
}

        // Get unique values for the current dropdown and sort them
        let array = [...new Set(dataset.map(element => element[fieldId]))];
        array = array.map(value => value === "" ? "(blank)" : value);
        array = array.sort();
        return array;
    };

    //Resetting the dropdowns
    const resetDropdowns = async () => {
        setScopeValue([]);
        setRealScopeValue([]);
        setSelectedUIAllFilters([]);
        setDropdownChanging(false);
        setTouchedFields(new Set());
        dispatch(setselectedUIAllFilters({ selectedUIAllFilters: [] }));
        onConfirm({
            emissionData: [],
            organisationalData: [],
            regionalData: [],
            customSpecificationData: []
        });
    };

    const getRecord = (scope, filteredByScopeArray, i, levelObj, type) => {
        if (type === 'Emission') {
            return {
                scope: scope,
                category_level1: levelObj?.category_level1,
                category_level2: levelObj?.category_level2,
                category_level3: levelObj?.category_level3,
                region_level1: filteredByScopeArray[i].region_level1,
                region_level2: filteredByScopeArray[i].region_level2,
                region_level3: filteredByScopeArray[i].region_level3,
                entity_level1: filteredByScopeArray[i]["entity_level1"],
                entity_level2: filteredByScopeArray[i]["entity_level2"],
                entity_level3: filteredByScopeArray[i]["entity_level3"],
                entity_level4: filteredByScopeArray[i]["entity_level4"],
                custom_specification1:
                    filteredByScopeArray[i]["custom_specification1"],
                custom_specification2:
                    filteredByScopeArray[i]["custom_specification2"],
                custom_specification3:
                    filteredByScopeArray[i]["custom_specification3"],
            };
        }
        if (type === 'Organisational') {
            return {
                scope: scope,
                category_level1: filteredByScopeArray[i]?.category_level1,
                category_level2: filteredByScopeArray[i]?.category_level2,
                category_level3: filteredByScopeArray[i]?.category_level3,
                region_level1: filteredByScopeArray[i].region_level1,
                region_level2: filteredByScopeArray[i].region_level2,
                region_level3: filteredByScopeArray[i].region_level3,
                entity_level1: levelObj?.entity_level1,
                entity_level2: levelObj?.entity_level2,
                entity_level3: levelObj?.entity_level3,
                entity_level4: levelObj?.entity_level4,
                custom_specification1:
                    filteredByScopeArray[i]["custom_specification1"],
                custom_specification2:
                    filteredByScopeArray[i]["custom_specification2"],
                custom_specification3:
                    filteredByScopeArray[i]["custom_specification3"],
            };
        }
        if (type === 'Regional') {
            return {
                scope: scope,
                category_level1: filteredByScopeArray[i]?.category_level1,
                category_level2: filteredByScopeArray[i]?.category_level2,
                category_level3: filteredByScopeArray[i]?.category_level3,
                region_level1: levelObj?.region_level1,
                region_level2: levelObj?.region_level2,
                region_level3: levelObj?.region_level3,
                entity_level1: filteredByScopeArray[i]?.entity_level1,
                entity_level2: filteredByScopeArray[i]?.entity_level2,
                entity_level3: filteredByScopeArray[i]?.entity_level3,
                entity_level4: filteredByScopeArray[i]?.entity_level4,
                custom_specification1:
                    filteredByScopeArray[i]["custom_specification1"],
                custom_specification2:
                    filteredByScopeArray[i]["custom_specification2"],
                custom_specification3:
                    filteredByScopeArray[i]["custom_specification3"],
            };
        }
        if (type === 'Custom') {
            return {
                scope: scope,
                category_level1: filteredByScopeArray[i]?.category_level1,
                category_level2: filteredByScopeArray[i]?.category_level2,
                category_level3: filteredByScopeArray[i]?.category_level3,
                region_level1: filteredByScopeArray[i]?.region_level1,
                region_level2: filteredByScopeArray[i]?.region_level2,
                region_level3: filteredByScopeArray[i]?.region_level3,
                entity_level1: filteredByScopeArray[i]?.entity_level1,
                entity_level2: filteredByScopeArray[i]?.entity_level2,
                entity_level3: filteredByScopeArray[i]?.entity_level3,
                entity_level4: filteredByScopeArray[i]?.entity_level4,
                custom_specification1: levelObj?.custom_specification1,
                custom_specification2: levelObj?.custom_specification2,
                custom_specification3: levelObj?.custom_specification3,
            };
        }
    }

    useEffect(() => {
        handleValidationForSelections();       
    }, [selectedUIfilters]);

    const handleValidationForSelections = () => {
        const possibleCombinations = hierarchialData; // API data
        const selectedCombinations = selectedUIfilters; // User's selected filters
        let errors = [];
        let err = [];

        // Check if the selected scope has valid combinations
        if (selectedCombinations.scope && selectedCombinations.scope.length > 0) {
            // Filter valid entries based on selected scopes
            const initialValidScopes = possibleCombinations.filter(item =>
                selectedCombinations.scope.includes(item.scope)
            );
            const recentlySelectedFilter = selectedCombinations.latest_filter;
            let recentlySelectedFilterLabel;
            keys?.map(data => {
                if (data?.field === recentlySelectedFilter) {
                    recentlySelectedFilterLabel = data?.headerName;
                }
            })
            const allOptions = possibleCombinations.map(item => item[recentlySelectedFilter]); // Extract all options based on the filter
            const uniqueAllOptions = [...new Set(allOptions)];
            const selectedCategories = selectedCombinations[recentlySelectedFilter];

            // Validate
            if (recentlySelectedFilter !== 'scope') {
                const validScopesToUse = validScopes.length > 0 ? validScopes : initialValidScopes;
                const allSelected = uniqueAllOptions?.length === selectedCategories?.length &&
                    uniqueAllOptions?.every(option => selectedCategories?.includes(option));
                selectedCombinations[recentlySelectedFilter]?.forEach(category => {
                    const validCategories = validScopesToUse?.filter(item => item[recentlySelectedFilter] === category);
                    if (validCategories?.length !== 0 && !allSelected) {
                        setValidScopes(validCategories);
                    }
                    validCategories?.map(item => {
                        if (!item[recentlySelectedFilter]?.includes(selectedCombinations[recentlySelectedFilter])) {
                            err.push(true);
                        }
                    })
                    //    if((err.length !== 0 || validCategories?.length === 0) && errors?.length === 0 && !allSelected){
                    //       errors.push(`Invalid selection for ${recentlySelectedFilterLabel}. It is not available for the selections.`);
                    //       keys?.forEach(key => {
                    //         if(selectedCombinations[key?.field]?.length === 0 || selectedCombinations[key?.field] == undefined){
                    //           disableDropdowns(key?.field);
                    //           setErrorInSelection(true);
                    //         }
                    //       })
                    //     }
                });
            }
        }
        // Set error messages if any
        if (errors.length > 0) {
            setErrorMsg(errors);
        } else {
            setErrorMsg([]); // Clear errors if valid
            setErrorInSelection(false);
        }
    };

    async function handleAllpayload(type, finalPayload) {
        let array = [];
        let filteredByScopeArray = [];
        if (selectedUIAllFilters?.scope) {
            filteredByScopeArray = hierarchialData.filter((element) =>
                selectedUIAllFilters?.scope.includes(element.scope)
            );
        } else {
            filteredByScopeArray = hierarchialData.filter((element) =>
                finalPayload?.scope?.includes(element.scope)
            );
        }
        let scopeArr = [];
        let categoryLevelObj = {};
        let orgLevelObj = {};
        let regionLevelObj = {};
        let customLevelObj = {};
        if (selectedUIAllFilters?.scope) {
            scopeArr = selectedUIAllFilters?.scope;
        } else {
            scopeArr = finalPayload?.scope;
        }
        if (type === 'Emission') {
            if (emissionSelectAllLevel === "subCategory1") {
                categoryLevelObj = {
                    category_level1: "All",
                    category_level2: "All",
                    category_level3: "All",
                };
                scopeArr?.forEach((scope) => {
                    for (let i = 0; i < filteredByScopeArray?.length; i++) {
                        if (scope === filteredByScopeArray[i]?.scope) {
                            let record = getRecord(scope, filteredByScopeArray, i, categoryLevelObj, type);
                            array.push(record);
                        }
                    }
                });
            }
            if (emissionSelectAllLevel === "subCategory2") {
                scopeArr?.forEach((scope) => {
                    for (let i = 0; i < filteredByScopeArray?.length; i++) {
                        categoryLevelObj = {
                            category_level1: filteredByScopeArray[i].category_level1,
                            category_level2: "All",
                            category_level3: "All",
                        };
                        if (scope === filteredByScopeArray[i]?.scope) {
                            let record = getRecord(scope, filteredByScopeArray, i, categoryLevelObj, type);
                            array.push(record);
                        }
                    }
                });
            }
            if (emissionSelectAllLevel === "subCategory3") {
                scopeArr?.forEach((scope) => {
                    for (let i = 0; i < filteredByScopeArray?.length; i++) {
                        if (scope === filteredByScopeArray[i]?.scope) {
                            categoryLevelObj = {
                                category_level1: filteredByScopeArray[i].category_level1,
                                category_level2: filteredByScopeArray[i].category_level2,
                                category_level3: "All",
                            };
                            let record = getRecord(scope, filteredByScopeArray, i, categoryLevelObj, type);
                            array.push(record);
                        }
                    }
                });
            }
        }

        if (type === 'Organisational') {
            if (orgSelectAllLevel === "orgLevel1") {
                orgLevelObj = {
                    entity_level1: "All",
                    entity_level2: "All",
                    entity_level3: "All",
                    entity_level4: "All",
                };
                scopeArr?.forEach((scope) => {
                    for (let i = 0; i < filteredByScopeArray?.length; i++) {
                        if (scope === filteredByScopeArray[i]?.scope) {
                            let record = getRecord(scope, filteredByScopeArray, i, orgLevelObj, type);
                            array.push(record);
                        }
                    }
                });
            }
            if (orgSelectAllLevel === "orgLevel2") {
                scopeArr?.forEach((scope) => {
                    for (let i = 0; i < filteredByScopeArray?.length; i++) {
                        orgLevelObj = {
                            entity_level1: filteredByScopeArray[i].entity_level1,
                            entity_level2: "All",
                            entity_level3: "All",
                            entity_level4: "All",
                        };
                        if (scope === filteredByScopeArray[i]?.scope) {
                            let record = getRecord(scope, filteredByScopeArray, i, orgLevelObj, type);
                            array.push(record);
                        }
                    }
                });
            }
            if (orgSelectAllLevel === "orgLevel3") {
                scopeArr?.forEach((scope) => {
                    for (let i = 0; i < filteredByScopeArray?.length; i++) {
                        if (scope === filteredByScopeArray[i]?.scope) {
                            orgLevelObj = {
                                entity_level1: filteredByScopeArray[i].entity_level1,
                                entity_level2: filteredByScopeArray[i].entity_level2,
                                entity_level3: "All",
                                entity_level4: "All",
                            };
                            let record = getRecord(scope, filteredByScopeArray, i, orgLevelObj, type);
                            array.push(record);
                        }
                    }
                });
            }
            if (orgSelectAllLevel === "orgLevel4") {
                scopeArr?.forEach((scope) => {
                    for (let i = 0; i < filteredByScopeArray?.length; i++) {
                        if (scope === filteredByScopeArray[i]?.scope) {
                            orgLevelObj = {
                                entity_level1: filteredByScopeArray[i].entity_level1,
                                entity_level2: filteredByScopeArray[i].entity_level2,
                                entity_level3: filteredByScopeArray[i].entity_level3,
                                entity_level4: "All",
                            };
                            let record = getRecord(scope, filteredByScopeArray, i, orgLevelObj, type);
                            array.push(record);
                        }
                    }
                });
            }
        }

        if (type === 'Regional') {
            if (regionSelectAllLevel === "regionLevel1") {
                regionLevelObj = {
                    region_level1: "All",
                    region_level2: "All",
                    region_level3: "All",
                };
                scopeArr?.forEach((scope) => {
                    for (let i = 0; i < filteredByScopeArray?.length; i++) {
                        if (scope === filteredByScopeArray[i]?.scope) {
                            let record = getRecord(scope, filteredByScopeArray, i, regionLevelObj, type);
                            array.push(record);
                        }
                    }
                });
            }
            if (regionSelectAllLevel === "regionLevel2") {
                scopeArr?.forEach((scope) => {
                    for (let i = 0; i < filteredByScopeArray?.length; i++) {
                        regionLevelObj = {
                            region_level1: filteredByScopeArray[i].region_level1,
                            region_level2: "All",
                            region_level3: "All",
                        };
                        if (scope === filteredByScopeArray[i]?.scope) {
                            let record = getRecord(scope, filteredByScopeArray, i, regionLevelObj, type);
                            array.push(record);
                        }
                    }
                });
            }
            if (regionSelectAllLevel === "regionLevel3") {
                scopeArr?.forEach((scope) => {
                    for (let i = 0; i < filteredByScopeArray?.length; i++) {
                        if (scope === filteredByScopeArray[i]?.scope) {
                            regionLevelObj = {
                                region_level1: filteredByScopeArray[i].region_level1,
                                region_level2: filteredByScopeArray[i].region_level2,
                                region_level3: "All",
                            };
                            let record = getRecord(scope, filteredByScopeArray, i, regionLevelObj, type);
                            array.push(record);
                        }
                    }
                });
            }
        }

        if (type === 'Custom') {
            if (customSelectAllLevel === "customLevel1") {
                customLevelObj = {
                    custom_specification1: "All",
                    custom_specification2: "All",
                    custom_specification3: "All",
                };
                scopeArr?.forEach((scope) => {
                    for (let i = 0; i < filteredByScopeArray?.length; i++) {
                        if (scope === filteredByScopeArray[i]?.scope) {
                            let record = getRecord(scope, filteredByScopeArray, i, customLevelObj, type);
                            array.push(record);
                        }
                    }
                });
            }
            if (customSelectAllLevel === "customLevel2") {
                scopeArr?.forEach((scope) => {
                    for (let i = 0; i < filteredByScopeArray?.length; i++) {
                        customLevelObj = {
                            custom_specification1: filteredByScopeArray[i].custom_specification1,
                            custom_specification2: "All",
                            custom_specification3: "All",
                        };
                        if (scope === filteredByScopeArray[i]?.scope) {
                            let record = getRecord(scope, filteredByScopeArray, i, customLevelObj, type);
                            array.push(record);
                        }
                    }
                });
            }
            if (customSelectAllLevel === "customLevel3") {
                scopeArr?.forEach((scope) => {
                    for (let i = 0; i < filteredByScopeArray?.length; i++) {
                        if (scope === filteredByScopeArray[i]?.scope) {
                            customLevelObj = {
                                custom_specification1: filteredByScopeArray[i].custom_specification1,
                                custom_specification2: filteredByScopeArray[i].custom_specification2,
                                custom_specification3: "All",
                            };
                            let record = getRecord(scope, filteredByScopeArray, i, customLevelObj, type);
                            array.push(record);
                        }
                    }
                });
            }
        }

        return array;
    }

    async function processEmissionData(finalPayload) {
        let uniqueEmiRecords = [];
        const subCategory3 = finalPayload?.category_level3;
        const subCategory2 = finalPayload?.category_level2;
        const subCategory1 = finalPayload?.category_level1;
        let hierarchyData = hierarchialData;
        let scopevalue = finalPayload?.scope;
        let filteredByScopeArray = hierarchyData?.filter((element) =>
            scopevalue?.includes(element.scope)
        );
        if (!selectedUIAllFilters?.scope?.length) {
            if (subCategory3?.length === 1 && subCategory3[0] === "N/A") {
                if (subCategory2?.length === 1 && subCategory2[0] === "N/A") {
                    if (subCategory1?.length === 1 && subCategory1[0] === "N/A") {
                        let record = {
                            scope: scopevalue[0],
                            category_level1: "",
                            category_level2: "",
                            category_level3: "",
                        };
                        uniqueEmiRecords?.push(record);
                    } else {
                        subCategory1.forEach((value) => {
                            let index = filteredByScopeArray?.findIndex(
                                (element) =>
                                    element?.category_level1 === value &&
                                    scopevalue?.includes(element.scope)
                            );
                            let record = {
                                scope: scopevalue[0],
                                category_level1: filteredByScopeArray[index]["category_level1"],
                                category_level2: filteredByScopeArray[index]["category_level2"],
                                category_level3: filteredByScopeArray[index]["category_level3"],
                                entity_level1: filteredByScopeArray[index]["entity_level1"],
                                entity_level2: filteredByScopeArray[index]["entity_level2"],
                                entity_level3: filteredByScopeArray[index]["entity_level3"],
                                entity_level4: filteredByScopeArray[index]["entity_level4"],
                                region_level1: filteredByScopeArray[index]["region_level1"],
                                region_level2: filteredByScopeArray[index]["region_level2"],
                                region_level3: filteredByScopeArray[index]["region_level3"],
                            };
                            uniqueEmiRecords?.push(record);
                        });
                    }
                } else {
                    subCategory2.forEach((value) => {
                        if (value !== "N/A") {
                            let index = filteredByScopeArray.findIndex(
                                (element) =>
                                    element.category_level2 === value &&
                                    scopevalue.includes(element.scope)
                            );
                            let record = {
                                scope: filteredByScopeArray[index]["scope"],
                                category_level1: filteredByScopeArray[index]["category_level1"],
                                category_level2: filteredByScopeArray[index]["category_level2"],
                                category_level3: filteredByScopeArray[index]["category_level3"],
                                entity_level1: filteredByScopeArray[index]["entity_level1"],
                                entity_level2: filteredByScopeArray[index]["entity_level2"],
                                entity_level3: filteredByScopeArray[index]["entity_level3"],
                                entity_level4: filteredByScopeArray[index]["entity_level4"],
                                region_level1: filteredByScopeArray[index]["region_level1"],
                                region_level2: filteredByScopeArray[index]["region_level2"],
                                region_level3: filteredByScopeArray[index]["region_level3"],
                            };
                            uniqueEmiRecords.push(record);
                        }
                    });
                }
            } else {
                subCategory3?.forEach((value) => {
                    for (let i = 0; i < filteredByScopeArray.length; i++) {
                        if (
                            value === filteredByScopeArray[i].category_level3 &&
                            scopevalue?.includes(filteredByScopeArray[i].scope) &&
                            subCategory1?.includes(filteredByScopeArray[i].category_level1) &&
                            subCategory2?.includes(filteredByScopeArray[i].category_level2)
                        ) {
                            let record = {
                                scope: filteredByScopeArray[i].scope,
                                category_level1: filteredByScopeArray[i].category_level1,
                                category_level2: filteredByScopeArray[i].category_level2,
                                category_level3: value,
                                region_level1: filteredByScopeArray[i].region_level1,
                                region_level2: filteredByScopeArray[i].region_level2,
                                region_level3: filteredByScopeArray[i].region_level3,
                                entity_level1: filteredByScopeArray[i]["entity_level1"],
                                entity_level2: filteredByScopeArray[i]["entity_level2"],
                                entity_level3: filteredByScopeArray[i]["entity_level3"],
                                entity_level4: filteredByScopeArray[i]["entity_level4"],
                                custom_specification1:
                                    filteredByScopeArray[i]["custom_specification1"],
                                custom_specification2:
                                    filteredByScopeArray[i]["custom_specification2"],
                                custom_specification3:
                                    filteredByScopeArray[i]["custom_specification3"],
                            };
                            uniqueEmiRecords.push(record);
                        }
                    }
                });
            }
        } else {
            filteredByScopeArray = hierarchyData?.filter((element) =>
                selectedUIAllFilters?.scope.includes(element.scope)
            );
            selectedUIAllFilters?.category_level3?.forEach((value) => {
                for (let i = 0; i < filteredByScopeArray.length; i++) {
                    if (
                        value === filteredByScopeArray[i].category_level3 &&
                        selectedUIAllFilters?.scope?.includes(filteredByScopeArray[i].scope) &&
                        selectedUIAllFilters?.category_level1.includes(
                            filteredByScopeArray[i].category_level1
                        ) &&
                        selectedUIAllFilters?.category_level2?.includes(
                            filteredByScopeArray[i].category_level2
                        )
                    ) {
                        let record = {
                            scope: filteredByScopeArray[i].scope,
                            category_level1: filteredByScopeArray[i].category_level1,
                            category_level2: filteredByScopeArray[i].category_level2,
                            category_level3: value,
                            region_level1: filteredByScopeArray[i].region_level1,
                            region_level2: filteredByScopeArray[i].region_level2,
                            region_level3: filteredByScopeArray[i].region_level3,
                            entity_level1: filteredByScopeArray[i]["entity_level1"],
                            entity_level2: filteredByScopeArray[i]["entity_level2"],
                            entity_level3: filteredByScopeArray[i]["entity_level3"],
                            entity_level4: filteredByScopeArray[i]["entity_level4"],
                            custom_specification1:
                                filteredByScopeArray[i]["custom_specification1"],
                            custom_specification2:
                                filteredByScopeArray[i]["custom_specification2"],
                            custom_specification3:
                                filteredByScopeArray[i]["custom_specification3"],
                        };
                        uniqueEmiRecords.push(record);
                    }
                }
            });
        }
        return uniqueEmiRecords;
    }

    async function processOrgData(finalPayload) {
        let uniqueRecords = [];

        const subOrg3 = finalPayload?.entity_level3;
        const subOrg2 = finalPayload?.entity_level2;
        const subOrg1 = finalPayload?.entity_level1;
        const subOrg4 = finalPayload?.entity_level4;

        let hierarchyData = hierarchialData;
        let scopevalue = finalPayload?.scope;
        let filteredByScopeArray = hierarchyData?.filter((element) =>
            scopevalue?.includes(element.scope)
        );
        if (!selectedUIAllFilters?.scope?.length) {
            if (subOrg3?.length === 1 && subOrg3[0] === "N/A") {
                if (subOrg2?.length === 1 && subOrg2[0] === "N/A") {
                    if (subOrg1?.length === 1 && subOrg1[0] === "N/A") {
                        let record = {
                            scope: scopevalue[0],
                            entity_level1: "",
                            entity_level2: "",
                            entity_level3: "",
                            entity_level4: "",
                        };
                        uniqueRecords?.push(record);
                    } else {
                        subOrg1?.forEach((value) => {
                            let index = filteredByScopeArray?.findIndex(
                                (element) => element?.entity_level1 === value);
                            if (index !== -1) {
                                let record = {
                                    scope: scopevalue[0],
                                    category_level1: filteredByScopeArray[index]["category_level1"],
                                    category_level2: filteredByScopeArray[index]["category_level2"],
                                    category_level3: filteredByScopeArray[index]["category_level3"],
                                    entity_level1: filteredByScopeArray[index]["entity_level1"],
                                    entity_level2: filteredByScopeArray[index]["entity_level2"],
                                    entity_level3: filteredByScopeArray[index]["entity_level3"],
                                    entity_level4: filteredByScopeArray[index]["entity_level4"],
                                    region_level1: filteredByScopeArray[index]["region_level1"],
                                    region_level2: filteredByScopeArray[index]["region_level2"],
                                    region_level3: filteredByScopeArray[index]["region_level3"],
                                };
                                uniqueRecords?.push(record);
                            }
                        });
                    }
                } else {
                    subOrg2?.forEach((value) => {
                        if (value !== "N/A") {
                            let index = filteredByScopeArray.findIndex(
                                (element) => element.entity_level2 === value);
                            if (index !== -1) {
                                let record = {
                                    scope: filteredByScopeArray[index]["scope"],
                                    category_level1: filteredByScopeArray[index]["category_level1"],
                                    category_level2: filteredByScopeArray[index]["category_level2"],
                                    category_level3: filteredByScopeArray[index]["category_level3"],
                                    entity_level1: filteredByScopeArray[index]["entity_level1"],
                                    entity_level2: filteredByScopeArray[index]["entity_level2"],
                                    entity_level3: filteredByScopeArray[index]["entity_level3"],
                                    entity_level4: filteredByScopeArray[index]["entity_level4"],
                                    region_level1: filteredByScopeArray[index]["region_level1"],
                                    region_level2: filteredByScopeArray[index]["region_level2"],
                                    region_level3: filteredByScopeArray[index]["region_level3"],
                                };
                                uniqueRecords.push(record);
                            }
                        }
                    });
                }
            } else {
                subOrg3?.forEach((value) => {
                    for (let i = 0; i < filteredByScopeArray.length; i++) {
                        if (
                            value === filteredByScopeArray[i].entity_level3 &&
                            scopevalue?.includes(filteredByScopeArray[i].scope) &&
                            subOrg1?.includes(filteredByScopeArray[i].entity_level1) &&
                            subOrg2?.includes(filteredByScopeArray[i].entity_level2)
                        ) {
                            let record = {
                                scope: filteredByScopeArray[i].scope,
                                category_level1: filteredByScopeArray[i].category_level1,
                                category_level2: filteredByScopeArray[i].category_level2,
                                category_level3: filteredByScopeArray[i].category_level3,
                                region_level1: filteredByScopeArray[i].region_level1,
                                region_level2: filteredByScopeArray[i].region_level2,
                                region_level3: filteredByScopeArray[i].region_level3,
                                entity_level1: filteredByScopeArray[i]["entity_level1"],
                                entity_level2: filteredByScopeArray[i]["entity_level2"],
                                entity_level3: filteredByScopeArray[i]["entity_level3"],
                                entity_level4: filteredByScopeArray[i]["entity_level4"],
                                custom_specification1:
                                    filteredByScopeArray[i]["custom_specification1"],
                                custom_specification2:
                                    filteredByScopeArray[i]["custom_specification2"],
                                custom_specification3:
                                    filteredByScopeArray[i]["custom_specification3"],
                            };
                            uniqueRecords.push(record);
                        }
                    }
                });
            }
        } else {
            filteredByScopeArray = hierarchyData.filter((element) =>
                selectedUIAllFilters?.scope.includes(element.scope)
            );
            selectedUIAllFilters?.entity_level3?.forEach((value) => {
                for (let i = 0; i < filteredByScopeArray.length; i++) {
                    if (
                        value === filteredByScopeArray[i]?.entity_level3 &&
                        selectedUIAllFilters?.scope?.includes(filteredByScopeArray[i]?.scope) &&
                        selectedUIAllFilters?.entity_level1?.includes(
                            filteredByScopeArray[i]?.entity_level1
                        ) &&
                        selectedUIAllFilters?.entity_level2?.includes(
                            filteredByScopeArray[i]?.entity_level2
                        )
                    ) {
                        let record = {
                            scope: filteredByScopeArray[i].scope,
                            category_level1: filteredByScopeArray[i].category_level1,
                            category_level2: filteredByScopeArray[i].category_level2,
                            category_level3: filteredByScopeArray[i].category_level3,
                            region_level1: filteredByScopeArray[i].region_level1,
                            region_level2: filteredByScopeArray[i].region_level2,
                            region_level3: filteredByScopeArray[i].region_level3,
                            entity_level1: filteredByScopeArray[i]["entity_level1"],
                            entity_level2: filteredByScopeArray[i]["entity_level2"],
                            entity_level3: filteredByScopeArray[i]["entity_level3"],
                            entity_level4: filteredByScopeArray[i]["entity_level4"],
                            custom_specification1:
                                filteredByScopeArray[i]["custom_specification1"],
                            custom_specification2:
                                filteredByScopeArray[i]["custom_specification2"],
                            custom_specification3:
                                filteredByScopeArray[i]["custom_specification3"],
                        };
                        uniqueRecords.push(record);
                    }
                }
            });
        }
        return uniqueRecords;
    }

    async function processRegionData(finalPayload) {
        let uniqueRecords = [];

        const subRegion3 = finalPayload?.region_level3;
        const subRegion2 = finalPayload?.region_level2;
        const subRegion1 = finalPayload?.region_level1;

        let hierarchyData = hierarchialData;
        let scopevalue = finalPayload?.scope;
        let filteredByScopeArray = hierarchyData?.filter((element) =>
            scopevalue?.includes(element.scope)
        );
        if (!selectedUIAllFilters?.scope?.length) {
            if (subRegion3?.length === 1 && subRegion3[0] === "N/A") {
                if (subRegion2?.length === 1 && subRegion2[0] === "N/A") {
                    if (subRegion1?.length === 1 && subRegion1[0] === "N/A") {
                        let record = {
                            scope: scopevalue[0],
                            region_level1: "",
                            region_level2: "",
                            region_level3: ""
                        };
                        uniqueRecords?.push(record);
                    } else {
                        subRegion1?.forEach((value) => {
                            let index = filteredByScopeArray?.findIndex(
                                (element) => element?.region_level1 === value);

                            let record = {
                                scope: scopevalue[0],
                                category_level1: filteredByScopeArray[index]["category_level1"],
                                category_level2: filteredByScopeArray[index]["category_level2"],
                                category_level3: filteredByScopeArray[index]["category_level3"],
                                entity_level1: filteredByScopeArray[index]["entity_level1"],
                                entity_level2: filteredByScopeArray[index]["entity_level2"],
                                entity_level3: filteredByScopeArray[index]["entity_level3"],
                                entity_level4: filteredByScopeArray[index]["entity_level4"],
                                region_level1: filteredByScopeArray[index]["region_level1"],
                                region_level2: filteredByScopeArray[index]["region_level2"],
                                region_level3: filteredByScopeArray[index]["region_level3"],
                            };
                            uniqueRecords?.push(record);
                        });
                    }
                } else {
                    subRegion2?.forEach((value) => {
                        if (value !== "N/A") {
                            let index = filteredByScopeArray.findIndex(
                                (element) => element.region_level2 === value);

                            if (index !== -1) {
                                let record = {
                                    scope: filteredByScopeArray[index]["scope"],
                                    category_level1: filteredByScopeArray[index]["category_level1"],
                                    category_level2: filteredByScopeArray[index]["category_level2"],
                                    category_level3: filteredByScopeArray[index]["category_level3"],
                                    entity_level1: filteredByScopeArray[index]["entity_level1"],
                                    entity_level2: filteredByScopeArray[index]["entity_level2"],
                                    entity_level3: filteredByScopeArray[index]["entity_level3"],
                                    entity_level4: filteredByScopeArray[index]["entity_level4"],
                                    region_level1: filteredByScopeArray[index]["region_level1"],
                                    region_level2: filteredByScopeArray[index]["region_level2"],
                                    region_level3: filteredByScopeArray[index]["region_level3"],
                                };
                                uniqueRecords.push(record);
                            }
                        }
                    });
                }
            } else {
                subRegion3?.forEach((value) => {
                    for (let i = 0; i < filteredByScopeArray.length; i++) {
                        if (
                            value === filteredByScopeArray[i].region_level3 &&
                            scopevalue?.includes(filteredByScopeArray[i].scope) &&
                            subRegion1?.includes(filteredByScopeArray[i].region_level1) &&
                            subRegion2?.includes(filteredByScopeArray[i].region_level2)
                        ) {
                            let record = {
                                scope: filteredByScopeArray[i].scope,
                                category_level1: filteredByScopeArray[i].category_level1,
                                category_level2: filteredByScopeArray[i].category_level2,
                                category_level3: filteredByScopeArray[i].category_level3,
                                region_level1: filteredByScopeArray[i].region_level1,
                                region_level2: filteredByScopeArray[i].region_level2,
                                region_level3: filteredByScopeArray[i].region_level3,
                                entity_level1: filteredByScopeArray[i]["entity_level1"],
                                entity_level2: filteredByScopeArray[i]["entity_level2"],
                                entity_level3: filteredByScopeArray[i]["entity_level3"],
                                entity_level4: filteredByScopeArray[i]["entity_level4"],
                                custom_specification1:
                                    filteredByScopeArray[i]["custom_specification1"],
                                custom_specification2:
                                    filteredByScopeArray[i]["custom_specification2"],
                                custom_specification3:
                                    filteredByScopeArray[i]["custom_specification3"],
                            };
                            uniqueRecords.push(record);
                        }
                    }
                });
            }
        } else {
            filteredByScopeArray = hierarchyData.filter((element) =>
                selectedUIAllFilters?.scope.includes(element.scope)
            );
            selectedUIAllFilters?.region_level3?.forEach((value) => {
                for (let i = 0; i < filteredByScopeArray.length; i++) {
                    if (
                        value === filteredByScopeArray[i].region_level3 &&
                        selectedUIAllFilters?.scope.includes(filteredByScopeArray[i].scope) &&
                        selectedUIAllFilters?.region_level1.includes(
                            filteredByScopeArray[i].region_level1
                        ) &&
                        selectedUIAllFilters?.region_level2.includes(
                            filteredByScopeArray[i].region_level2
                        )
                    ) {
                        let record = {
                            scope: filteredByScopeArray[i].scope,
                            category_level1: filteredByScopeArray[i].category_level1,
                            category_level2: filteredByScopeArray[i].category_level2,
                            category_level3: filteredByScopeArray[i].category_level3,
                            region_level1: filteredByScopeArray[i].region_level1,
                            region_level2: filteredByScopeArray[i].region_level2,
                            region_level3: filteredByScopeArray[i].region_level3,
                            entity_level1: filteredByScopeArray[i]["entity_level1"],
                            entity_level2: filteredByScopeArray[i]["entity_level2"],
                            entity_level3: filteredByScopeArray[i]["entity_level3"],
                            entity_level4: filteredByScopeArray[i]["entity_level4"],
                            custom_specification1:
                                filteredByScopeArray[i]["custom_specification1"],
                            custom_specification2:
                                filteredByScopeArray[i]["custom_specification2"],
                            custom_specification3:
                                filteredByScopeArray[i]["custom_specification3"],
                        };
                        uniqueRecords.push(record);
                    }
                }
            });
        }

        return uniqueRecords;
    }

    async function processCustomData(finalPayload) {
        let uniqueRecords = [];

        const subCustom3 = finalPayload?.custom_specification3;
        const subCustom2 = finalPayload?.custom_specification2;
        const subCustom1 = finalPayload?.custom_specification1;

        let hierarchyData = hierarchialData;
        let scopevalue = finalPayload?.scope;
        let filteredByScopeArray = hierarchyData?.filter((element) =>
            scopevalue?.includes(element.scope)
        );

        if (!selectedUIAllFilters?.scope?.length) {
            subCustom3?.forEach((value) => {
                if (value !== "N/A") {
                    for (let i = 0; i < filteredByScopeArray?.length; i++) {
                        if (
                            value === filteredByScopeArray[i]?.custom_specification3 &&
                            scopevalue?.includes(filteredByScopeArray[i].scope) &&
                            subCustom1?.includes(
                                filteredByScopeArray[i]?.custom_specification1
                            ) &&
                            subCustom2?.includes(
                                filteredByScopeArray[i]?.custom_specification2
                            )
                        ) {
                            let record = {
                                scope: filteredByScopeArray[i]?.scope,
                                category_level1: filteredByScopeArray[i]?.category_level1,
                                category_level2: filteredByScopeArray[i]?.category_level2,
                                category_level3: filteredByScopeArray[i]?.category_level3,
                                region_level1: filteredByScopeArray[i]?.region_level1,
                                region_level2: filteredByScopeArray[i]?.region_level2,
                                region_level3: filteredByScopeArray[i]?.region_level3,
                                entity_level1: filteredByScopeArray[i]["entity_level1"],
                                entity_level2: filteredByScopeArray[i]["entity_level2"],
                                entity_level3: filteredByScopeArray[i]["entity_level3"],
                                entity_level4: filteredByScopeArray[i]["entity_level4"],
                                custom_specification1:
                                    filteredByScopeArray[i]["custom_specification1"],
                                custom_specification2:
                                    filteredByScopeArray[i]["custom_specification2"],
                                custom_specification3:
                                    filteredByScopeArray[i]["custom_specification3"],
                            };
                            uniqueRecords.push(record);
                        }
                    }
                }
            });
        } else {
            filteredByScopeArray = hierarchyData.filter((element) =>
                selectedUIAllFilters?.scope?.includes(element.scope)
            );
            selectedUIAllFilters?.custom_specification3?.forEach((value) => {
                if (value !== "N/A") {
                    for (let i = 0; i < filteredByScopeArray.length; i++) {
                        if (
                            value === filteredByScopeArray[i].region_level3 &&
                            selectedUIAllFilters?.scope?.includes(filteredByScopeArray[i].scope) &&
                            selectedUIAllFilters.custom_specification1.includes(
                                filteredByScopeArray[i].custom_specification1
                            ) &&
                            selectedUIAllFilters.custom_specification2.includes(
                                filteredByScopeArray[i].custom_specification2
                            )
                        ) {
                            let record = {
                                scope: filteredByScopeArray[i].scope,
                                category_level1: filteredByScopeArray[i].category_level1,
                                category_level2: filteredByScopeArray[i].category_level2,
                                category_level3: filteredByScopeArray[i].category_level3,
                                region_level1: filteredByScopeArray[i].region_level1,
                                region_level2: filteredByScopeArray[i].region_level2,
                                region_level3: filteredByScopeArray[i].region_level3,
                                entity_level1: filteredByScopeArray[i]["entity_level1"],
                                entity_level2: filteredByScopeArray[i]["entity_level2"],
                                entity_level3: filteredByScopeArray[i]["entity_level3"],
                                entity_level4: filteredByScopeArray[i]["entity_level4"],
                                custom_specification1:
                                    filteredByScopeArray[i]["custom_specification1"],
                                custom_specification2:
                                    filteredByScopeArray[i]["custom_specification2"],
                                custom_specification3:
                                    filteredByScopeArray[i]["custom_specification3"],
                            };
                            uniqueRecords.push(record);
                        }
                    }
                }
            });
        }
        return uniqueRecords;
    }

    //Applying the filters
    const applyFilters = async (selectedUIfilters) => {
        setDropdownChanging(false);
        setLoader(true);
        const allFields = keys
            ?.map(k => k.field);
        
        const cleanedPayload = Object.fromEntries(
            Object.entries(selectedUIfilters)?.filter(
                ([_, value]) => !(Array.isArray(value) && value?.length === 0)
            )
        );

        const presentFields = Object.keys(cleanedPayload);
        const missingFields = allFields?.filter(
            field => !presentFields?.includes(field)
        );

        const finalPayload = { ...selectedUIfilters };
        missingFields?.forEach(fieldId => {
            const value = finalPayload[fieldId];
            if (!Array.isArray(value) || value?.length === 0) {
                finalPayload[fieldId] = getDropdownValues(fieldId) ?? [];
                if (!selectedUIfilters[fieldId]) {
                    selectedUIfilters[fieldId] = []; // Initialize as an empty array if it doesn't exist
                }

        // Assuming finalPayload[fieldId] is a single value or an array of values
        const valuesToAdd = Array.isArray(finalPayload[fieldId]) ? finalPayload[fieldId] : [finalPayload[fieldId]];

        // Use a Set to avoid duplicates
        const uniqueValues = new Set(selectedUIfilters[fieldId]);

        valuesToAdd.forEach(value => {
            uniqueValues.add(value); // Add each value to the Set
        });

        // Convert the Set back to an array and assign it to selectedUIfilters[fieldId]
        selectedUIfilters[fieldId] = Array.from(uniqueValues);
            }            
        });

        const customValues = ['custom_specification1', 'custom_specification2', 'custom_specification3'];
        customValues.forEach(key => {
            if (Array.isArray(finalPayload[key])) {
                finalPayload[key] = finalPayload[key].map(value => value === "(blank)" ? "" : value);
            }
        });

        // Helper - if field was touched by user, return actual values; otherwise return "All"
        const getConsolidatedValue = (fieldId) => {
            if (touchedFields.has(fieldId)) {
                return finalPayload[fieldId] || [];
            }
            return ["All"];
        };

        // Emmission Records
        const uniqueRecords = await processEmissionData(finalPayload);
        const allRecords = await handleAllpayload('Emission', finalPayload);
        const newRecords = {
            records: uniqueRecords,
            scope: getConsolidatedValue('scope'),
            category_level1: getConsolidatedValue('category_level1'),
            category_level2: getConsolidatedValue('category_level2'),
            category_level3: getConsolidatedValue('category_level3'),
            allPayload: allRecords?.length > 0 ? allRecords : uniqueRecords,
            selectAll: emissionSelectAllLevel,
            functionality: !selectedUIAllFilters?.scope ? "Save" : "Edit",
        };
        
        // Organisational Records
        const uniqueOrgRecords = await processOrgData(finalPayload);
        const allOrgRecords = await handleAllpayload('Organisational', finalPayload);
        const newOrgRecords = {
            records: uniqueOrgRecords,
            entity_level1: getConsolidatedValue('entity_level1'),
            entity_level2: getConsolidatedValue('entity_level2'),
            entity_level3: getConsolidatedValue('entity_level3'),
            entity_level4: getConsolidatedValue('entity_level4'),
            allPayload: allOrgRecords?.length > 0 ? allOrgRecords : uniqueOrgRecords,
            selectAll: orgSelectAllLevel,
            functionality: !selectedUIAllFilters?.scope ? "Save" : "Edit",
        };

        // Regional Records
        const uniqueRegionRecords = await processRegionData(finalPayload);
        const allRegionRecords = await handleAllpayload('Regional', finalPayload);
        const newRegionRecords = {
            records: uniqueRegionRecords,
            region_level1: getConsolidatedValue('region_level1'),
            region_level2: getConsolidatedValue('region_level2'),
            region_level3: getConsolidatedValue('region_level3'),
            allPayload: allRegionRecords?.length > 0 ? allRegionRecords : uniqueRegionRecords,
            selectAll: regionSelectAllLevel,
            functionality: !selectedUIAllFilters?.scope ? "Save" : "Edit",
        };

        // Custom Specification Records
        const uniqueCustomRecords = await processCustomData(finalPayload);
        const allCustomRecords = await handleAllpayload('Custom', finalPayload);
        const newCustomRecords = {
            records: uniqueCustomRecords,
            custom_specification1: getConsolidatedValue('custom_specification1'),
            custom_specification2: getConsolidatedValue('custom_specification2'),
            custom_specification3: getConsolidatedValue('custom_specification3'),
            allPayload: allCustomRecords?.length > 0 ? allCustomRecords : uniqueCustomRecords,
            selectAll: customSelectAllLevel,
            functionality: !selectedUIAllFilters?.scope ? "Save" : "Edit",
        };

        onConfirm({
            emissionData: newRecords,
            organisationalData: newOrgRecords,
            regionalData: newRegionRecords,
            customSpecificationData: newCustomRecords
        });

        console.log('newRecords', {
            emissionData: newRecords,
            organisationalData: newOrgRecords,
            regionalData: newRegionRecords,
            customSpecificationData: newCustomRecords
        })

        dispatch(
            setselectedUIAllFilters({ selectedUIAllFilters: finalPayload })
        );
        dispatch(
            setSelectedAllLevels({
                selectedAllLevels: {
                    emissionLevel: emissionSelectAllLevel,
                    orgLevel: orgSelectAllLevel,
                    geoLevel: regionSelectAllLevel,
                    cusLevel: customSelectAllLevel
                }
            })
        );

        setLoader(false);
        onApply();
    };

    return (
        <div className="add-gmp-hieraachry-container">
            <div className="emission-filter-modal-content">
                {dropdowns.map((element) => {
                    return (
                        <div className="emission-filter-modal-content-main">
                            <span className="emission-filter-modal-label" key={element.Name}>
                                {element.Name} &nbsp;
                                <Tooltip
                                    trigger={<EmissionIcon />}
                                    variant="ghost"
                                    tooltipText={element.tooltip}
                                ></Tooltip>
                            </span>
                            <div className="emission-filter-modal-content-dropdowns">
                                {element.dropdownList.map((dropdown) => {
                                    return (
                                        <div>
                                            <span className="emission-filter-modal-content-dropdowns-label">
                                                {dropdown.label}                                               
                                            </span>
                                            <Select
                                                options={getDropdownValues(dropdown.fieldId)}
                                                disabled={errorInSelection ? disableDropdowns(dropdown.label) : false}
                                                value={
                                                    selectedUIfilters[dropdown.fieldId]
                                                        ? selectedUIfilters[dropdown.fieldId]
                                                        : []
                                                }
                                                onChange={(event) => {
                                                    handleDropdownChange(
                                                        event,
                                                        dropdown.fieldId,
                                                        dropdown.id
                                                    );
                                                }}
                                                multiple={true}
                                                showSelectAllButton={true}
                                            ></Select>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>
            <div className="emission-filter-modal-footer">
                {errorMsg && (
                    <div style={{ color: 'red', marginTop: '10px' }}>
                        {errorMsg}
                    </div>
                )}
                <Button
                    variant="primary-alt"
                    onClick={() => {
                        resetDropdowns();
                    }}
                    disabled={!hasValidEntries}
                >
                    {reset}
                </Button>
                <LoadingIndicatorEmbed show={showLoader}>
                    <Button
                        variant="primary"
                        onClick={() => applyFilters(selectedUIfilters)}
                        disabled={!hasValidEntries}
                        className={"decarb-dataselection-apply-btn"}
                    >
                        {ApplyBtn}
                    </Button>
                </LoadingIndicatorEmbed>
            </div>
        </div>
    );
}

export function M2FilterModal({ isFilterOpen, onClose, onConfirm, selectedValueFilters }) {
    return (
        <Modal
            show={isFilterOpen}
            onClose={onClose}
            header={
                <div className="emission-filter-modal-header">
                    <span>{DataSelection}<span className="required-star">*</span></span>
                    <Tooltip
                        trigger={<EmissionIcon />}
                        variant="ghost"
                        tooltipText={emissionFilterTooltip}
                    ></Tooltip>
                </div>
            }
            body={<ModalBody onApply={onClose} onConfirm={onConfirm} selectedValueFilters={selectedValueFilters}></ModalBody>}
            className={"emission-gmp-modal"}

        ></Modal>
    );
}
